import { createTheme, responsiveFontSizes } from '@mui/material';
export const primaryMainColor = '#039be5';
export function createMaterialTheme() {
    let theme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: primaryMainColor,
            },
        },
    });
    theme = responsiveFontSizes(theme, { factor: 3 });
    return theme;
}
//# sourceMappingURL=Theming.js.map